import { useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";

const CodeCard = (props) => {
  const code = props.code;
  const [copied, setCopied] = useState(false);

  return (
    <Row className="mt-2 py-3 border d-flex align-items-center bg-light">
      <Col xs={12} className="d-flex justify-content-center">
        <span className="h4 p-3"> كود الخصم: </span>
        <span className="h3 border p-3"> {code.code}</span>
        
      </Col>
      <Col xs={12} className="text-center mt-2">
        <p className="h5">{code.dAr}</p>
      </Col>
      <Col xs={12} className="text-center mt-2">
      <CopyToClipboard text={code.code} onCopy={() => setCopied(!copied)}>
          <Button>نسخ كود الخصم</Button>
        </CopyToClipboard>
        {copied ? (
          <div style={{ color: "red" }} className="h5 mt-1">تم نسخ كود الخصم 😁✌️</div>
        ) : 
        null
        }
        </Col>
    </Row>
  );
};

export default CodeCard;
